import { ca } from '@cian/analytics';
import { EServiceId, EUnavailableReason } from '../../../reducers';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../types/analytics';
import { getFormId } from '../../../../../browser/services/formId';
const debounce = require('lodash/debounce');

interface ITrackBetTypingParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  selectedServiceId: EServiceId | null;
  currentBet: number | null;
  offerPosition: number | null;
  page: number | null;
}

export const trackBetTyping = debounce((params: ITrackBetTypingParams) => {
  const { analyticsOfferStatus, analyticsProduct, selectedServiceId, offerPosition, page, currentBet } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_type_bid',
    label: currentBet,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        vas: selectedServiceId,
        position: offerPosition,
        page_number: page,
      },
    },
  });
}, 1000);

interface ITrackBetChangeParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  sign: string;
  selectedServiceId: EServiceId | null;
  currentBet: number | null;
  offerPosition: number | null;
  page: number | null;
}

export const trackBetChange = debounce((params: ITrackBetChangeParams) => {
  const { analyticsOfferStatus, analyticsProduct, sign, selectedServiceId, offerPosition, page, currentBet } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_change_bid',
    label: sign,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        bid: currentBet,
        vas: selectedServiceId,
        position: offerPosition,
        page_number: page,
      },
    },
  });
}, 1000);

interface ITrackServiceClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  serviceId: EServiceId | null;
  currentBet: number | null;
  offerPosition: number | null;
  page: number | null;
}

export const trackServiceClick = (params: ITrackServiceClickParams) => {
  const { analyticsOfferStatus, analyticsProduct, serviceId, offerPosition, page, currentBet } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_change_vas',
    label: serviceId,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        bid: currentBet,
        position: offerPosition,
        page_number: page,
        form_id: getFormId(),
      },
    },
  });
};

interface ITrackUnavailableServiceClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  unavailableReason: EUnavailableReason | null;
}

const UNAVAILABLE_REASON_MAP = {
  [EUnavailableReason.noPhotos]: 'no_photo',
  [EUnavailableReason.onlyInAction]: 'rch',
  [EUnavailableReason.deniedBySanctions]: 'sanctions',
  [EUnavailableReason.top3ServiceDenied]: 'top_not_available',
  [EUnavailableReason.onlyAfterPremiumServiceExpiration]: 'premium_timeout',
};

export const trackUnavailableServiceClick = (params: ITrackUnavailableServiceClickParams) => {
  const { analyticsOfferStatus, analyticsProduct, unavailableReason } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_click_unavailable_vas',
    label: UNAVAILABLE_REASON_MAP[unavailableReason!],
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        form_id: getFormId(),
      },
    },
  });
};
